export const infrastructure = [
  "800 beds",
  "150+ Intensive Care Beds",
  " 20+ Operation Theatres",
  " 24+ Diagnostic Centers ",
  " 4+ Cath Labs",
  " PET CT Scanners ",
  " 3 Linear Accelerators ",
  " 16 MRI Machines ",
  "6 CT Scanners",
  " Da vinci Robotic Surgery System",
];

export const staff = [
  " 60+ Nurses ",
  "30+ Janitors",
  " 5+ Receptionists ",
  "50+ Helpers",
  "6+ Ambulance with drivers ",
];
